import { takeLatest, call, put } from 'redux-saga/effects';
import {
  FETCH_RECENT_ACTIVITY,
  fetchingRecentActivity,
  fetchRecentActivitySuccess,
  fetchRecentActivityFailed,
} from '../actions/activity';

import { firestore } from '../utils/firebase';
import { convertCollection } from '../utils/helper';

// function enrich(activity) {
//   return fetchDoc(getTenantPath(`/employees/${activity.userId}`))
//     .then((employee) => {
//       activity.employee = employee;
//       return activity;
//     })
//     .then(() => {
//       if (activity.taskId) {
//         return fetchDoc(getTenantPath(`/tasks/${activity.taskId}`))
//           .then((task) => {
//             activity.task = task;
//             return activity;
//           });
//       }
//
//       return activity;
//     });
// }

function fetchRecentActivity(jobId, limit = 10) {
  return firestore.collection(`jobs/${jobId}/activity`)
    .orderBy('at', 'desc')
    .limit(limit)
    .get()
    .then(convertCollection);
    // .catch((err) => {
    //   console.error('Could not retrieve data', err);
    //   reject(err);
    // });
    // .then((activities) => Promise.all(toArray(activities).map(enrich)).then(() => activities));
}

function* fetchRecentActivitySaga(action) {
  try {
    yield put(fetchingRecentActivity(action.jobId));
    const activity = yield call(fetchRecentActivity, action.jobId, action.limit);
    yield put(fetchRecentActivitySuccess(action.jobId, activity));
  } catch (e) {
    console.error('Unable to fetch recent activity', e);
    yield put(fetchRecentActivityFailed(action.jobId, e));
  }
}

function* watchFetchRecentActivitySaga() {
  yield takeLatest(FETCH_RECENT_ACTIVITY, fetchRecentActivitySaga);
}

export {
  watchFetchRecentActivitySaga,
};



// WEBPACK FOOTER //
// ./src/sagas/activity.js